<!--
  表格列渲染组件(支持嵌套)
  抽离自 gljy-table.vue 中的列渲染逻辑,目的是:
    1. 支持 columnItem.children 嵌套配置多级表头;
    2. 通过递归渲染,理论上支持任意层级嵌套;
    3. 保持与原版一致的列属性(prop / label / fixed / align / sortable / show-overflow-tooltip / header-align / min-width);
    4. **不传 :width prop**(关键):gljy-table 的 columnSetupMethods 会把 columnItem.width 默认设为 100,
       如果显式传给 el-table-column 会强制按 width 计算列宽,导致列无法填满右侧空白。
       原版只传 min-width,列宽由 el-table 根据内容/min-width/maxWidth 自动撑满;
       4. 叶子列(没有 children)走默认渲染逻辑(orderNumber / rowNumber / slotSetting / 普通值),
       也通过 bodyCell 插槽把控制权交给调用方,与原版完全兼容。
  调用方传入的 bodyCell 插槽会在递归过程中被透传,这样调用方无需感知嵌套深度,
  仍然只需要写一份 bodyCell 即可对所有叶子列生效。
-->
<template>
  <el-table-column :prop="hasChildren ? undefined : columnItem.dataIndex" :label="columnItem.title"
    :fixed="columnItem.fixed" :align="columnItem.align ? columnItem.align : 'center'"
    :sortable="columnItem.sortable"
    :show-overflow-tooltip="columnItem.ellipsis !== null ? columnItem.ellipsis : (columnItem.dataIndex != 'operation' ? true : false)"
    :header-align="columnItem.headerAlign"
    :min-width="columnItem.minWidth ? columnItem.minWidth : undefined">
    <!-- 有子列:作为多级表头的"组标题",递归渲染子列 -->
    <template v-if="hasChildren" #default>
      <table-column v-for="child in columnItem.children" :key="child.dataIndex" :columnItem="child"
        :pagination="pagination">
        <template #bodyCell="slotProps">
          <slot name="bodyCell" v-bind="slotProps" />
        </template>
      </table-column>
    </template>
    <!-- 叶子列:渲染单元格内容 -->
    <template v-else #default="{ row, column, $index }">
      <slot name="bodyCell" :columnItem="columnItem" :row="row" :column="column" :index="$index">
        <!-- 默认渲染逻辑(与原 gljy-table 一致,保证向后兼容) -->
        <template v-if="columnItem.dataIndex == 'orderNumber'">
          {{ $index + 1 }}
        </template>
        <template v-else-if="columnItem.dataIndex == 'rowNumber'">
          {{ (pagination.current - 1) * pagination.pageSize + ($index + 1) }}
        </template>
        <template v-else-if="columnItem?.slotSetting">
          <tableSlot :value="row[columnItem.dataIndex]" :slotSetting="columnItem.slotSetting" :record="row" />
        </template>
        <template v-else>
          {{ row[columnItem.dataIndex] }}
        </template>
      </slot>
    </template>
  </el-table-column>
</template>

<script>
import tableSlot from "./table-slot.vue";

export default {
  // 递归组件必须设置 name,模板里才能直接写 <table-column>
  name: "table-column",
  components: {
    tableSlot,
  },
  props: {
    // 当前列配置:支持嵌套(通过 children 属性递归)
    columnItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 分页信息(用于 rowNumber 列的序号计算)
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否为多级表头的父级列(存在 children 且至少一个)
    hasChildren() {
      return Array.isArray(this.columnItem?.children) && this.columnItem.children.length > 0;
    },
  },
};
</script>
